import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'PrettyID'
})
export class PrettyIDPipe implements PipeTransform {

  transform(value: any, args?: any): any {
        if ( value === undefined ) {
          return value;
        }
        let v = value.toString();
    		return v === '0' ? '' : '0000'.substring(0, '0000'.length - v.length) + v;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/pretty-id.pipe.ts